import * as Sentry from "@sentry/react";
import { esErrorDeRed } from "./axios";

// Reporta a Sentry un error que deja al usuario en la pantalla "No pudimos continuar con tu trámite".
// Se agrupa por acción y status (no por trámite). Los cortes de red del usuario no se reportan:
// ya tienen su aviso propio (GESTDOC-FLOW-FRONTEND-5). Sin Sentry iniciado (local) no hace nada.
export default function reportarError(err, accion, transaction) {
  const deAxios = Boolean(err && err.isAxiosError);
  if (deAxios && esErrorDeRed(err)) return;
  // Trámite inexistente (enlace mal copiado o id de otra cosa): el backend responde 404 y no es una falla
  if (accion === "getDocumento" && err && err.response && err.response.status === 404) return;
  try {
    const status = err && err.response ? err.response.status : deAxios ? "sin respuesta" : "error js";
    const data = err && err.response ? err.response.data : deAxios ? null : err && err.message;
    let mensaje = data && data.message !== undefined ? data.message : data;
    if (mensaje && typeof mensaje !== "string") mensaje = JSON.stringify(mensaje);
    Sentry.withScope((scope) => {
      scope.setFingerprint(["procedure-error", accion, String(status)]);
      scope.setTag("accion", accion);
      scope.setTag("status", String(status));
      if (transaction) scope.setTag("transaction_id", transaction);
      if (mensaje) scope.setExtra("respuesta", String(mensaje).slice(0, 500));
      if (err && err.config) scope.setExtra("url", `${err.config.method} ${err.config.url}`);
      Sentry.captureException(new Error(`${accion} falló (${status})${mensaje ? `: ${String(mensaje).slice(0, 200)}` : ""}`));
    });
  } catch (e) {
    console.error("[sentry]", e);
  }
}
